module.exports = ".qr-modal-body .qr-modal-image {\n  margin: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/shared/components/qr-modal/qr-modal.component.scss
// module id = 588
// module chunks = 8